import { useState } from 'react'
import { Cpu, KeyRound } from 'lucide-react'

export default function KioskPareamento({ onParear }: { onParear: (token: string) => void }) {
  const [token, setToken] = useState('')
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-br from-violet-50 to-blue-50">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 space-y-6">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-violet-100 text-violet-600 mb-2">
            <Cpu className="h-8 w-8" />
          </div>
          <h1 className="text-2xl font-bold text-ink-900">Parear máquina</h1>
          <p className="text-sm text-ink-500">
            Cole o token de pareamento gerado no cadastro da máquina, ou bipa o QR Code
          </p>
        </div>

        <div className="space-y-3">
          <label className="block text-xs uppercase text-ink-500 font-medium">Token</label>
          <textarea
            value={token}
            onChange={(e) => setToken(e.target.value.trim())}
            placeholder="Ex: aBc123_xyz..."
            rows={3}
            className="w-full px-4 py-3 border-2 border-ink-200 focus:border-violet-500 rounded-xl text-base font-mono"
            autoFocus
          />
          <button
            onClick={() => token && onParear(token)}
            disabled={!token}
            className="w-full h-14 bg-violet-600 hover:bg-violet-700 active:bg-violet-800 text-white font-semibold rounded-xl flex items-center justify-center gap-2 disabled:opacity-40 transition"
          >
            <KeyRound className="h-5 w-5" /> Parear
          </button>
        </div>

        <p className="text-xs text-ink-400 text-center">
          O token é gerado em Industrial → Máquinas → ⋮ → Token de pareamento
        </p>
      </div>
    </div>
  )
}
